// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"780":"9e962f7a","3716":"9e962f7a","4264":"9e962f7a","4591":"9e962f7a","6019":"9e962f7a","8549":"da60a4f5","8891":"9e962f7a","9628":"9e962f7a"}[chunkId] + ".chunk.css";
};